<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="title"
    type-modal="puzzle_form_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

       <d-form-row class="form-group">
          <d-col cols="12">
            <label>Nome:</label>
            <d-form-input type="text" v-model="model.name" :state="hasErrorFiled('name')"/>
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>
       <d-form-row class="form-group">
          <d-col cols="6">
            <label>Qtd. Letra:</label>
            <select v-model="model.letter" class="form-control">
              <option :value="5">5</option>
              <option :value="6">6</option>
              <option :value="7">7</option>
              <option :value="8">8</option>
              <option :value="9">9</option>
            </select>
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
          <d-col cols="6">
            <label>Publicação:</label>
            <datepicker
              class="mb-2"
              type="datetime"
              format="DD/MM/YYYY | HH:mm"
              :model.sync="model.published_date"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>
        <d-form-row class="form-group">
          <d-col cols="6">
            <label>Palavra:</label>
             <autocomplete
              ref="searchWord"
              placeholder="Escreva a palavra"
              :items="words"
              item-show="word"
              :on-input="onInputWord"
              :on-select="setWord"
              :on-blur="validateWord"
              :state="hasErrorFiled('word')"
            ></autocomplete>
            <d-form-invalid-feedback>Palavra é obrigatório</d-form-invalid-feedback>
          </d-col>
          <d-col cols="6">
            <label>Tentativas:</label>
            <d-form-input type="text" v-model="model.attempt" :state="hasErrorFiled('attempt')"/>
            <d-form-invalid-feedback>Tentativas é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
        :disabled="disabled"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep, stringfy, getDateTimeUTCISO } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import ModalTemplate from '_shared/Modal.vue';
import Autocomplete from '_common/shared/Autocomplete.vue';
import WordService from '_services/rest/modules/word';
import PuzzleService from '_services/rest/modules/puzzle-term';
import {
  MODEL,
  _LOAD_MODEL_,
  _UPDATE_PUZZLE_PAGINATION_,
} from './PuzzleTermModel';

export default {
  name: 'puzzle-term-form',
  mixins: [mixin, formatErrors],
  components: {
    Datepicker,
    Autocomplete,
    ModalTemplate,
  },
  props: {
    puzzle: {
      type: Object,
      default: cloneDeep(MODEL),
    },
  },
  computed: {
    title() {
      if (this.puzzle.id) {
        return 'Editar termo';
      }
      return 'Novo termo';
    },
    model: {
      get() {
        return this.puzzle;
      },
      set(value) {
        this.$emit('update:puzzle', value);
      },
    },
  },
  data() {
    return {
      words: [],
      errors: {
        name: { required: false },
        word: { required: false },
        attempt: { required: false },
      },
      disabled: true,
    };
  },
  methods: {
    ...mapActions([
      'setPuzzle',
      'setToggle',
      'activeAlert',
    ]),
    cancel() {
      this.setToggle({ type: 'puzzle_form_modal', bool: false });
    },
    onInputWord(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getWords(name);
      }, 500);
    },
    getWords(params) {
      WordService.getWords({ search: params, letter: this.model.letter })
        .then(response => {
          this.words = response.list;
        });
    },
    setWord(word) {
      this.model.word = word.word;
    },
    validateWord(param) {
      this.disabled = true;
      this.errors.word.required = true;
      this.model.word = param;
      if (this.model.word.length === this.model.letter) {
        this.disabled = false;
        this.errors.word.required = false;
      }
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.published_date = getDateTimeUTCISO(this.model.published_date);
        PuzzleService.save(this.model)
          .then(response => {
            this.model = response;
            this.$store.commit('setPuzzleTerm', response);
            Events.$emit(_UPDATE_PUZZLE_PAGINATION_, { page: 1 });
            this.cancel();
          })
          .catch(error => {
            const errors = this.formatErrors(error.data);
            this.activeAlert({ message: errors, theme: 'danger' });
          });
      }
    },
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, model => {
      this.model = model;
      this.$nextTick(() => {
        this.disabled = true;
        if (this.model.id) {
          this.disabled = false;
        }
        if (this.$refs.searchWord && this.$refs.searchWord) {
          this.$refs.searchWord.$refs.input.value = this.model.word;
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
ul {
  &.options {
    list-style: none;
    padding: 0;
  }
}
</style>
